import React from 'react'
import { useState, useEffect } from 'react';
import axios from 'axios';


function DocumentCommentStats({ documentId }) {

    const [dcStats, setDcStats] = useState({
        "Comments": 0,
        "Debators": 0,
        "Yea": 0,
        "Nea": 0
    });
    const getDcStats = async () => {
        axios
            .get("/api/v1/comments/statsByDocument/" + documentId)
            .then((result) => setDcStats(result.data))
            .catch((err) => console.log(err));
    }

    useEffect(() => {
        getDcStats();
    }, []);


    return (
        <div>
            <p>{dcStats.Debators} Debators</p>
            <p>{dcStats.Comments} Comments</p>
            <p>
                {dcStats.Yea}<img src="/graphics/icons/hand-thumbs-up.svg" alt="like" />
                {" "}
                <img src="/graphics/icons/hand-thumbs-down.svg" alt="dislike" />{dcStats.Nea}
            </p>
        </div>
    )
}

export default DocumentCommentStats
